<template>
  <div
    class="hidden md:block z-40 bg-gradient-to-b from-[#e8e8e8] via-[#e4e4e4] to-[#ffffff] dark:from-[#191a1d] dark:to-[#1d1e21] opacity-90 w-full h-[100px] fixed bottom-0 blur-lg bg-blend-multiply"
  ></div>
  <footer
    class="z-40 hidden mx-auto md:flex flex-col w-full md:w-[98%] xl:w-[80%] justify-center items-center fixed bottom-8 inset-x-0"
  >
    <span class="hidden xl:block absolute left-[-40px] top-[0px]">
      <img
        class="w-[81px] h-[81px]"
        width="81"
        height="81"
        src="https://storage.googleapis.com/face-api-public-assets/assets/orb.png"
        alt="Orb"
      />
    </span>
    <div
      class="flex flex-row border-[2px] bg-gradient-to-b from-[#fefefe] via-[#f2f2f2] to-[#e8e8e8] dark:from-jungle dark:via-jungle dark:to-jungle border-[#dfdfdf] dark:border-[#23252a] w-full h-[81px] justify-start items-center rounded-lg"
    >
      <div class="hidden lg:flex ml-4 xl:ml-[50px] mr-4">
        <ModeSwitch />
      </div>
      <div class="hidden lg:flex items-center mr-2 lg:mr-6 min-w-[126px]">
        <LangMenu :current="t('locale')" />
      </div>
      <!-- Auth Check -->
      <div class="flex flex-row justify-around w-full">
        <FooterAction :stats="stats" @toggle="onToggle" />
      </div>
      <!--# End Auth check -->
    </div>
    <!-- Footer menu -->
    <div class="flex flex-row mt-4">
      <div
        class="flex items-start px-3 text-xs font-bold text-vulcan dark:text-white"
      >
        {{ new Date().getFullYear() }} &copy {{ t("copyright") }}
      </div>
      <div
        class="flex flex-row mt-2 divide-x divider-vulcan dark:divide-white lg:mt-0"
      >
        <div
          class="px-3 text-xs font-bold text-center text-vulcan dark:text-white hover:text-fire dark:hover:text-gold trans"
        >
          <a
            target="_blank"
            title="{{t('faq')}}"
            href="https://facecoalition.com/faq"
            >{{ t("faq") }}</a
          >
        </div>
        <div
          class="px-3 text-xs font-bold text-center text-vulcan dark:text-white hover:text-fire dark:hover:text-gold trans"
        >
          <a
            target="_blank"
            title="{{t('privacy')}}"
            href="https://facecoalition.com/privacy"
            >{{ t("privacy") }}</a
          >
        </div>
        <div
          class="px-3 text-xs font-bold text-center text-vulcan dark:text-white hover:text-fire dark:hover:text-gold trans"
        >
          <a
            title="Helpdesk"
            target="_blank"
            href="https://helpdesk.facecoalition.com/"
            >{{ t("help") }}</a
          >
        </div>
        <div
          class="px-3 text-xs font-bold text-center text-vulcan dark:text-white hover:text-fire dark:hover:text-gold trans"
        >
          <a
            target="_blank"
            title="{{t('menu.resources')}}"
            href="https://facecoalition.com/resources"
            >{{ t("menu.resources") }}</a
          >
        </div>
        <a
          href="/user/profile"
          class="px-3 text-xs font-bold text-center text-vulcan dark:text-white hover:text-fire dark:hover:text-gold trans"
          >{{ t("menu.profile2") }}</a
        >
        <a
          href="/logout"
          class="px-3 text-xs font-bold text-center text-vulcan dark:text-white hover:text-fire dark:hover:text-gold trans"
          >{{ t("menu.logout") }}</a
        >
      </div>
    </div>
    <!-- Footer menu -->
  </footer>
</template>

<script>
import ModeSwitch from "./ModeSwitch";
import LangMenu from "./LangMenu";
import FooterAction from "./FooterAction";
import { useI18n } from "vue-i18n";

export default {
  name: "FooterComponent",
  components: { FooterAction, LangMenu, ModeSwitch },
  props: {
    stats: {
      type: Object,
      default: {},
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const onToggle = (type, value) => {
      emit("toggle", type, value);
    };

    return {
      t,
      onToggle,
    };
  },
};
</script>
